<template>
  <transition name="fade">
    <div v-if="isOpen" :class="$style.root" class="window position-fixed d-flex flex-column bg-gray-100">
      <header class="d-flex py-4 align-items-center px-3">
        <button class="ml-auto btn-reset p-2" @click="toggleAbout">
          <img id="mk-close-help" src="../assets/shopping/vlm/fechar-icon-verde.svg" alt="">
        </button>
      </header>

      <div class="scroll flex-fill px-4">
        <img src="../assets/ilustração-info.svg" class="w-100 h-auto" alt="">

        <div class="text-center">
          <h2 class="font-size-5 py-3 font-weight-bold text-vlm">
            Multiplan Inteligência Artificial
          </h2>
          <p class="font-size-2 m-0 text-body">
            Como assistente virtual estou aqui pra te ajudar com suas dúvidas pelo shopping. Fica a vontade para me perguntar sobre funcionamento das lojas, restaurantes, delivery ou o que precisar.
</p>

          <h2 class="font-size-5 py-3 font-weight-bold text-vlm">
            Comece a conversa
          </h2>
        </div>

        <button v-for="(item, i) in items"
                :key="i"
                id="mk-suggestion-help"
                class="btn-reset d-flex align-items-center rounded-lg bg-light w-100 p-3 mb-3"
                style="text-align: left;"
                @click="onClickItem(item)">
          <img :src="item.icon" width="30px" height="auto" alt="">
          <div class="ml-3 ">
            <div class="font-size-2 font-weight-bold text-vlm">
              {{ item.title }}
            </div>
            <div class="font-size-2 text-body">
              {{ item.subtitle }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mapState, mapActions} from 'vuex';

  export default {
    name: 'About',
    data() {
      return {
        items: [
          {
            icon: require('../assets/delivery.svg'),
            title: 'Como funciona o delivery?',
            subtitle: 'Tire suas dúvidas'
          },
          {
            icon: require('../assets/loja-icon.svg'),
            title: 'Quero buscar uma loja',
            subtitle: 'Ache uma loja'
          },
          {
            icon: require('../assets/hamburger.svg'),
            title: 'Quero ver as hamburguerias',
            subtitle: 'Busque por restaurantes'
          }

        ]
      };
    },
    computed: {
      ...mapState({
        isOpen: state => state.isAboutOpen
      })
    },
    methods: {
      ...mapActions(['toggleAbout', 'sendMessage']),
      onClickItem(item) {
        this.toggleAbout();
        this.sendMessage(item.title);
      }
    }
  }
</script>

<style lang="scss" module>
  .root {
    z-index: 1020;
    left: 0;
    top: 0;
    width: 100%;
    width: 100vw;
    height: 100%;
    height: 100vh;
  }
</style>
